import React from 'react';
import CookieList from '../components/Policies/CookieList';

function Cookie() {
  return (
    <CookieList />
  )
}

export default Cookie;